module.exports = __webpack_public_path__ + "static/img/report_bg2.97210104.png";